import { useMemo } from 'react';
import { Column } from '~/commonComponents';
import { IDraftJobPostEntity } from '~/domain/PermanentJobs';
import { UserProfession, UserSubProfession } from '~/enums/UserProfession';
import { EducationUtils } from '~/utils/EducationUtils';
import { EnumHelper } from '~/utils/EnumHelper';
import { Colors } from '~/themes/colors';
import { InfoSection } from './InfoSection';
import { LabelValueDisplay } from './LabelValueDisplay';

interface IJobInformationReviewProps {
  jobPosting: IDraftJobPostEntity;
  onEditClick: () => void;
}

export const JobInformationReview = ({ jobPosting, onEditClick }: IJobInformationReviewProps) => {
  const fmtProfessionalType = useMemo(() => {
    const profToDisplay = jobPosting.subProfession || jobPosting.professionType;
    if (!profToDisplay) return '';

    const isSubProfession = EnumHelper.getObjectKeys(UserSubProfession).includes(profToDisplay);
    return isSubProfession
      ? UserSubProfession.getName(profToDisplay)
      : UserProfession.getName(profToDisplay);
  }, [jobPosting.professionType, jobPosting.subProfession]);

  return (
    <InfoSection
      title="Job Information"
      titleColor="neutral_600"
      titleFontSize={24}
      rightActionIcon="edit-pencil"
      onRightActionPress={onEditClick}
      containerStyle={{ backgroundColor: Colors.white, paddingInline: 40 }}
    >
      <Column gap={14}>
        <LabelValueDisplay label="Office Name" value={jobPosting.officeName} />
        <LabelValueDisplay label="Job Title" value={jobPosting.title} />
        <LabelValueDisplay label="Professional Type" value={fmtProfessionalType} />
        <LabelValueDisplay
          label="Specialty"
          value={EducationUtils.removeSpecialtyPrefix(jobPosting.officeSpecialty || '')}
        />
      </Column>
    </InfoSection>
  );
};
